import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              <span className="text-info">PIL ANDINA S.A. © Copyright </span>{" "}
              {new Date().getFullYear()} All Rights Reserved.
            </Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block"></div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
